import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { VetGroup } from '../../vet-group/vet-group';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import {
    Tierarzt,
    VetGroupVet,
} from '../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';

@Component({
    selector: 'kiene-vet-vet-group-details-dialog',
    templateUrl: './vet-vet-group-details-dialog.component.html',
    styleUrls: ['./vet-vet-group-details-dialog.component.scss'],
})
export class VetVetGroupDetailsDialogComponent implements OnInit {
    tierarzt: Tierarzt;
    myVetGroups: VetGroupVet[] = [];

    constructor(
        public dialogRef: MatDialogRef<VetVetGroupDetailsDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
        private readonly api: KieneTableService,
        private readonly notification: MessageService,
    ) {
        this.tierarzt = data.tierarzt;
    }

    ngOnInit() {
        this.loadVetGroupsForVet();
    }

    loadVetGroupsForVet() {
        if (this.tierarzt) {
            const params = new HttpParams().append('tierarzt_id', this.tierarzt.tierarzt_id.toString());
            this.api.get(this.apiBaseUrl + 'tierarztgruppe_tierarzt/read.php', params).subscribe(response => {
                this.myVetGroups = response.records;
            });
        }
    }

    setVetGroup(vg: VetGroup) {
        const vgv = new VetGroupVet();
        vgv.tierarztgruppe_id = vg.tierarztgruppe_id;
        vgv.tierarztgruppe = vg.bezeichnung;
        vgv.tierarzt_id = this.tierarzt.tierarzt_id;
        this.myVetGroups.push(vgv);
        this.saveVetGroupVet(vgv);
    }

    saveVetGroupVet(vgv: VetGroupVet) {
        this.api.post(this.apiBaseUrl + 'tierarztgruppe_tierarzt/create.php', vgv, null).subscribe(
            () => {
                this.loadVetGroupsForVet();
                this.notification.infoMessage('Tierarztgruppe wurde erfolgreich hinzugefügt.');
            },
            error => {
                this.notification.errorMessage('Fehler: Tierarztgruppe konnte nicht hinzugefügt werden!', error);
            },
        );
    }

    removeVetGroupFromVet(vgv: VetGroupVet) {
        this.api.deleteEntity(this.apiBaseUrl + 'tierarztgruppe_tierarzt/delete.php', vgv).subscribe(
            () => {
                this.loadVetGroupsForVet();
                this.notification.infoMessage('Tierarztgruppe wurde erfolgreich entfernt.');
            },
            error => {
                this.notification.errorMessage('Fehler: Tierarztgruppe konnte nicht entfernt werden!', error);
            },
        );
    }

    cancel() {
        this.dialogRef.close();
    }
}
